export default __webpack_public_path__ + "static/media/segments-image.2b1eb389.jpeg";